export default {
  UNPAID: {
    value: 110,
    label: '待付款',
  },
  PAID: {
    value: 111,
    label: '已付款',
  },
  rufunding: {
    value: 112,
    label: '退款中',
  },
  rufund: {
    value: 113,
    label: '已退款',
  },
}